export default "__VITE_PUBLIC_ASSET__cd12e55b__"